import type { SearchType } from '@tyro/api';

export function getSearchPathWithPreservedTab(
  basePaths: Partial<Record<SearchType, string>>,
  partyId: number,
  type: SearchType,
  currentPathname: string,
  fallbackPath: string,
): string {
  const basePath = basePaths[type];
  if (!basePath) return fallbackPath;

  const basePathWithTrailingSlash = `${basePath}/`;
  if (currentPathname.startsWith(basePathWithTrailingSlash)) {
    const pathAfterBase = currentPathname.slice(
      basePathWithTrailingSlash.length,
    );
    const subPathStartIndex = pathAfterBase.indexOf('/');
    const subPath =
      subPathStartIndex !== -1 ? pathAfterBase.slice(subPathStartIndex) : '';
    return `${basePath}/${partyId}${subPath}`;
  }

  return `${basePath}/${partyId}`;
}
